
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmSignalFail as ObiAlarmSignalFailElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-signal-fail.js';
 
 
 

 
 export const ObiAlarmSignalFail = createComponent({
   react: React,
   tagName: 'obi-alarm-signal-fail',
   elementClass: ObiAlarmSignalFailElement,
   events: {
     
   }
  });
 
 